import { css, styled } from 'canoe';
import React from 'react';

import { Image as ImageIcon } from 'craft/icons';

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.GlitterGrayL10};
    padding: ${theme.spaces.s} ${theme.spaces.normal};
  `}
`;

export const ImagePlaceholder = () => (
  <Container data-cy="image-placeholder">
    <ImageIcon width={30} />
  </Container>
);
